import React from "react";
import MainSection from "./components/MainSection";
import { useSelector } from "react-redux";

const Main = () => {
  const theme = useSelector((state) => state.theme.theme);
  return (
    <div>
      <div
        className={
          theme === "light"
            ? " mx-w-7xl mx-auto pt-20 px-6 min-h-screen"
            : " mx-w-7xl mx-auto pt-20 px-6 min-h-screen bg-gray-900 text-white"
        }
      >
        <MainSection className=" h-screen" />
      </div>
    </div>
  );
};

export default Main;
